import { render, staticRenderFns } from "./ModalAddNewReportItem.vue?vue&type=template&id=850912a6&scoped=true"
import script from "./ModalAddNewReportItem.vue?vue&type=script&lang=js"
export * from "./ModalAddNewReportItem.vue?vue&type=script&lang=js"
import style0 from "./ModalAddNewReportItem.vue?vue&type=style&index=0&id=850912a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "850912a6",
  null
  
)

export default component.exports